module.exports = __webpack_public_path__ + "static/media/17.ca096692.png";